<template>
  <div class="giras-page">
    <div class="giras-container">
      <!-- Coluna da Esquerda - Texto -->
      <div class="text-column left-column">
        <h1>GIRAS</h1>
        <div class="schedule">
          <p><strong>Terça-feira:</strong> das 20:00 às 22:00</p>
          <p><strong>Quarta-feira:</strong> das 20:00 às 22:00</p>
          <p><strong>Quinta-feira:</strong> das 20:00 às 22:00</p>
          <p><strong>Sábado:</strong> das 10:00 às 12:00</p>
          <p><strong>Sábado:</strong> das 15:00 às 17:00</p>
        </div>
      </div>

      <!-- Coluna do Centro - Imagens Sobrepostas -->
      <div class="images-column">
        <div class="stacked-images">
          <div class="image-wrapper image-1">
            <img src="@/assets/boiadeiro_01.jpg" alt="Gira no Templo EDEM" class="stacked-image" />
          </div>
          <div class="image-wrapper image-2">
            <img src="@/assets/boiadeiro_02.jpg" alt="Gira no Templo EDEM" class="stacked-image" />
          </div>
          <div class="image-wrapper image-3">
            <img src="@/assets/boiadeiro_03.jpg" alt="Gira no Templo EDEM" class="stacked-image" />
          </div>
          <div class="image-wrapper image-4">
            <img src="@/assets/ciganos_01.jpg" alt="Gira no Templo EDEM" class="stacked-image" />
          </div>
        </div>
      </div>

      <!-- Coluna da Direita - Texto -->
      <div class="text-column right-column">
        <div class="description">
          <p>No terreiro trabalhamos com diferentes linhas da Umbanda:</p>
          <ul class="umbanda-lines">
            <li>Elegbara</li>
            <li>Malandros</li>
            <li>Baianos</li>
            <li>Boiadeiros</li>
            <li>Marinheiros</li>
            <li>Crianças</li>
            <li>Ciganos</li>
            <li>Caboclos</li>
            <li>Pretos-velhos</li>
          </ul>
          <p class="instagram-link">
            Consulte nosso Instagram <strong>@TemploEDEM</strong> para atualizações.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GirasPage',
  mounted() {
    console.log('GirasPage component mounted');
  }
};
</script>

<style scoped>
.giras-page {
  padding: 2rem;
  background-color: #ffefbc;
  min-height: 70vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.giras-container {
  display: flex;
  max-width: 1200px;
  width: 100%;
  gap: 3rem;
  align-items: flex-start;
  justify-content: space-between;
}

/* Colunas de Texto */
.text-column {
  flex: 1;
  min-width: 250px;
}

.left-column {
  text-align: left;
}

.right-column {
  text-align: left;
}

h1 {
  font-family: 'Abhaya Libre', serif;
  font-size: 3rem;
  font-weight: bold;
  color: #000;
  margin-bottom: 2rem;
  text-align: center;
}

.schedule p {
  font-family: 'Amiri', serif;
  font-size: 1.2rem;
  line-height: 1.6;
  margin-bottom: 1rem;
  color: #000;
}

.schedule strong {
  color: #0a5162;
}

.description p {
  font-family: 'Amiri', serif;
  font-size: 1.2rem;
  line-height: 1.6;
  margin-bottom: 1.5rem;
  color: #000;
}

.umbanda-lines {
  font-family: 'Amiri', serif;
  font-size: 1.1rem;
  line-height: 1.1;
  color: #000;
  margin-bottom: 1.5rem;
  padding-left: 1.5rem;
}

.umbanda-lines li {
  margin-bottom: 0.5rem;
  list-style-type:none;
}

.instagram-link {
  font-style: italic;
  color: #0a5162;
}

/* Coluna das Imagens Sobrepostas */
.images-column {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 300px;
  position: relative;
}

.stacked-images {
  position: relative;
  width: 300px;
  height: 400px;
}

.image-wrapper {
  position: absolute;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  transition: transform 0.3s ease, z-index 0.3s ease;
}

.image-wrapper:hover {
  transform: scale(1.05);
  z-index: 10;
}

.stacked-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

/* Posicionamento das imagens sobrepostas */
.image-1 {
  width: 250px;
  height: 300px;
  top: 0;
  left: 0;
  transform: rotate(-5deg);
  z-index: 4;
}

.image-2 {
  width: 250px;
  height: 300px;
  top: 50px;
  left: 25px;
  transform: rotate(2deg);
  z-index: 3;
}

.image-3 {
  width: 250px;
  height: 300px;
  top: 100px;
  left: 50px;
  transform: rotate(6deg);
  z-index: 2;
}
.image-4 {
  width: 250px;
  height: 300px;
  top: 115px;
  left: 80px;
  transform: rotate(10deg);
  z-index: 1;
}

/* Versão Mobile */
@media (max-width: 921px) {
  .giras-page {
    padding: 1rem;
    min-height: auto;
  }

  .giras-container {
    flex-direction: column;
    gap: 2rem;
    align-items: center;
  }

  .text-column {
    width: 100%;
    max-width: 100%;
    text-align: center;
  }

  h1 {
    font-size: 2.5rem;
    margin-bottom: 1.5rem;
  }

  .schedule p,
  .description p {
    font-size: 1.1rem;
  }

  .images-column {
    order: -1; /* Imagens primeiro no mobile */
    margin: 1rem 0;
  }

  .stacked-images {
    width: 250px;
    height: 350px;
  }

  .image-1,
  .image-2,
  .image-3,
  .image-4 {
    width: 200px;
    height: 250px;
  }

  .image-1 {
    top: 0;
    left: 0;
    transform: rotate(-3deg);
  }

  .image-2 {
    top: 40px;
    left: 20px;
    transform: rotate(1deg);
  }

  .image-3 {
    top: 80px;
    left: 40px;
    transform: rotate(4deg);
  }
  .image-4 {
    top: 100px;
    left: 60px;
    transform: rotate(7deg);
  }
}

/* Versão Desktop Pequena */
@media (min-width: 922px) and (max-width: 1100px) {
  .giras-container {
    gap: 2rem;
  }

  .stacked-images {
    width: 280px;
    height: 350px;
  }

  .image-1,
  .image-2,
  .image-3,
  .image-4 {
    width: 230px;
    height: 280px;
  }
  .image-4{
    left:60px;
    transform: rotate(9deg);
  }
}
</style>